// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1_container__2vR8a","text":"Section1_text__1kSIm","point1":"Section1_point1__wEhuR","point2":"Section1_point2__2hfE3","screen":"Section1_screen__LXx-1"};